import { HashRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <div className="min-h-screen bg-background-200">
        <HashRouter>
          <AppRoutes />
        </HashRouter>
      </div>
    </I18nextProvider>
  );
}

export default App;